import { Component, effect, input, output, viewChild, ChangeDetectionStrategy } from '@angular/core';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { NotificationSetting } from '../../../../../viewmodels/apple/profiles/notifications-profile/notification-setting.model';
import { NotificationsProfile } from '../../../../../viewmodels/apple/profiles/notifications-profile/notifications-profile.model';
import { NotificationSettingComponent } from '../notification-setting/notification-setting.component';

@Component({
  selector: 'ml-mdm-notifications-profile',
  templateUrl: './notifications-profile.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [FaIconComponent, NotificationSettingComponent],
})
export class NotificationsProfileComponent {
  private readonly newNotificationSettingComponent =
    viewChild.required<NotificationSettingComponent>('newNotificationSettings');

  readonly notificationsProfile = input.required<NotificationsProfile>();
  readonly mutate = input(false);

  readonly notificationsProfileChange = output<NotificationsProfile>();

  public selectedItem: number | null = null;

  newNotificationSetting = new NotificationSetting();
  internalNotificationsProfile: NotificationsProfile;

  constructor() {
    effect(() => {
      this.internalNotificationsProfile = this.notificationsProfile();
      if (!this.mutate()) {
        this.internalNotificationsProfile = new NotificationsProfile();
        this.internalNotificationsProfile.notificationSettings = this.notificationsProfile().notificationSettings; // TODO Deepcopy
      }
    });
  }

  doneEditing() {
    return true;
  }

  add() {
    const newNotificationSettingComponent = this.newNotificationSettingComponent();
    if (!newNotificationSettingComponent.doneEditing()) {
      return;
    }

    let notificationsProfile = this.notificationsProfile();
    const mutate = this.mutate();
    if (!mutate) {
      notificationsProfile = new NotificationsProfile();
      notificationsProfile.notificationSettings = this.notificationsProfile().notificationSettings; // TODO Deepcopy
    }
    notificationsProfile.notificationSettings.push(this.newNotificationSetting);

    this.newNotificationSetting = new NotificationSetting();
    newNotificationSettingComponent.editing = true;

    if (mutate) {
      this.notificationsProfileChange.emit(notificationsProfile);
    }

    this.internalNotificationsProfile = notificationsProfile;
  }

  remove(notificationSetting: NotificationSetting) {
    let notificationsProfile = this.notificationsProfile();
    const mutate = this.mutate();
    if (!mutate) {
      notificationsProfile = new NotificationsProfile();
      notificationsProfile.notificationSettings = this.notificationsProfile().notificationSettings; // TODO Deepcopy
    }

    const index = notificationsProfile.notificationSettings.findIndex((profile) => notificationSetting === profile);
    notificationsProfile.notificationSettings.splice(index);
    if (mutate) {
      this.notificationsProfileChange.emit(notificationsProfile);
    }
  }
}
